import React from 'react'
import LiquidityForm from './LiquidityForm'

function LiquidityHold() {
    return (
        <div className="header-offset">
            <div className='bg-one'>
                <h3 className='text-center text-light pt-5'>Liquidity Hodl</h3>
            </div>

            <div>
                <div className='container pt-5 pb-5 new-s'>
                    <h3 className='pb-5'>
                        Please complete the form below to process your purchase. Tokens will be transferred to your provided ERC-20 address within 2-3 business day after confirmation.
                    </h3>

                    <LiquidityForm />
                </div>
            </div>
        </div>
    )
}


export default LiquidityHold